// bit shifting

import { TMessageSigfoxOut } from '../entities/ric003'

export function hexStringToArrayBuffer(hexString: string): Uint8Array {
  // remove the leading 0x
  hexString = hexString.replace(/^0x/, '')

  // ensure even number of characters
  if (hexString.length % 2 != 0) {
    console.log(
      'WARNING: expecting an even number of characters in the hexString'
    )
  }

  // check for some non-hex characters
  var bad = hexString.match(/[G-Z\s]/i)
  if (bad) {
    console.log('WARNING: found non-hex characters', bad)
  }

  // split the string into pairs of octets
  var pairs = hexString.match(/[\dA-F]{2}/gi)

  // convert the octets to integers
  if (pairs) {
    var integers = pairs.map(function (s) {
      return parseInt(s, 16)
    })

    return new Uint8Array(integers)
  }

  return new Uint8Array(0)
}

export function convertToFloat32(bytes: Uint8Array) {
  var bits = (bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3]
  var sign = bits >>> 31 == 0 ? 1.0 : -1.0
  var e = (bits >>> 23) & 0xff
  var m = e == 0 ? (bits & 0x7fffff) << 1 : (bits & 0x7fffff) | 0x800000
  var f = sign * m * Math.pow(2, e - 150)
  return f
}

export function getUniqueDevices(messages: TMessageSigfoxOut[]) {
  return messages
    .map((message) => message.SIGFOX_ID)
    .filter((v, i, a) => a.indexOf(v) === i)
}
